(() => {
  class BalaoFooter {
    constructor(root) {
      this.root = root;
      this.form = root.querySelector('.balao-footer__newsletter-form');
      this.defaultBlock = root.querySelector('[data-balao-newsletter-default]');
      this.successBlock = root.querySelector('[data-balao-newsletter-success]');
      this.submitBtn = root.querySelector('[data-balao-newsletter-submit]');
      this.accordions = [...root.querySelectorAll('.balao-footer__accordion')];
      this.allowNative = false;
      this.#bind();
      this.#syncAccordions();
    }

    #bind() {
      this.form?.addEventListener('submit', (event) => this.#onSubmit(event));
      window.addEventListener('resize', () => this.#syncAccordions());
    }

    #syncAccordions() {
      const desktop = window.innerWidth >= 990;
      this.accordions.forEach((details) => {
        if (desktop) details.open = true;
      });
    }

    async #onSubmit(event) {
      if (!this.form || this.allowNative) return;
      event.preventDefault();

      const email = this.form.querySelector('input[type="email"]');
      if (!email?.value) return;

      this.submitBtn?.setAttribute('disabled', 'true');
      this.submitBtn?.classList.add('is-loading');

      try {
        const formData = new FormData(this.form);
        const action = this.form.getAttribute('action') || `${window.Shopify?.routes?.root || '/'}contact`;
        const response = await fetch(action, {
          method: 'POST',
          body: formData,
          headers: { Accept: 'application/json' },
        });

        if (!response.ok && response.status !== 302) {
          throw new Error('newsletter_failed');
        }

        this.#showSuccess();
      } catch (error) {
        this.allowNative = true;
        this.form.submit();
      } finally {
        this.submitBtn?.removeAttribute('disabled');
        this.submitBtn?.classList.remove('is-loading');
      }
    }

    #showSuccess() {
      if (this.defaultBlock) this.defaultBlock.hidden = true;
      if (this.successBlock) this.successBlock.hidden = false;
    }
  }

  const boot = () => {
    document.querySelectorAll('[data-balao-footer]').forEach((root) => {
      if (root.dataset.balaoFooterReady) return;
      root.dataset.balaoFooterReady = 'true';
      new BalaoFooter(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
